// GraphLoader.tsx
import React from 'react';
import styled from '@emotion/styled';
import { Skeleton } from 'antd';
import { BarChartOutlined, LineChartOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

const LoaderWrapper = styled.div`
  width: 100%;
  height: ${({ height }) => height || '320px'};
  border-radius: 12px;
  padding: 24px;
  background: #fff;
  display: flex;
  justify-content: center;

  .skeleton {
    width: 100% !important;
  }
`;

const iconStyle = { fontSize: 250, color: '#bfbfbf', margin: '20px' };

const Icons = {
  bar: <BarChartOutlined style={iconStyle} />,
  line: <LineChartOutlined style={iconStyle} />
};

const GraphLoader = ({ type = 'bar', height }) => {
  return (
    <LoaderWrapper height={height}>
      <Skeleton.Node prefixCls="skeleton" active style={{ width: '100%', height: '100%' }}>
        {Icons[type]}
      </Skeleton.Node>
    </LoaderWrapper>
  );
};

export default GraphLoader;

GraphLoader.propTypes = {
  type: PropTypes.string,
  height: PropTypes.string
};
